export const getJobsList = state => state.getIn(['jobs', 'list'])
export const getPage = state => state.getIn(['jobs', 'page'])
export const getCount = state => state.getIn(['jobs', 'count'])
export const getAscendant = state => state.getIn(['jobs', 'ascendant'])
